module.exports = __webpack_public_path__ + "static/media/Rectangle.2d237a55.svg";